
import request from '../utils/request' //引入刚刚写好的request文件
//账号登录
export function login(params) {
    return request({
        url: '/api/user/login',
        method: 'post',
        params: params
    })
}
//发送验证码
export function send(params) {
    return request({
        url: '/api/sms/send',
        method: 'post',
        params: params
    })
}
//注册
export function register(params) {
    return request({
        url: '/api/user/register',
        method: 'post',
        params: params
    })
}
//手机号登录
export function mobilelogin(params) {
    return request({
        url: '/api/user/mobilelogin',
        method: 'post',
        params: params
    })
}
//修改密码
export function resetpwd(params) {
    return request({
        url: '/api/user/resetpwd',
        method: 'post',
        params: params
    })
}
//banner
export function banner(params) {
    return request({
        url: '/api/index/banner',
        method: 'get',
        params: params
    })
}
//网站信息
export function index(params) {
    return request({
        url: '/api/index/index',
        method: 'get',
        params: params
    })
}
//元素周期表
export function element(params) {
    return request({
        url: '/api/index/element',
        method: 'get',
        params: params
    })
}
//产品分类
export function getShopCategory(params) {
    return request({
        url: '/api/index/getShopCategory',
        method: 'get',
        params: params
    })
}
//文章分类
export function newsCategory(params) {
    return request({
        url: '/api/index/newsCategory',
        method: 'get',
        params: params
    })
}
//文章list
export function newsList(params) {
    return request({
        url: '/api/index/newsList',
        method: 'get',
        params: params
    })
}
//文章detail
export function newsDetail(params) {
    return request({
        url: '/api/index/newsDetail',
        method: 'post',
        params: params
    })
}
//首页分类以及十个产品
export function getGoodsList(params) {
    return request({
        url: '/api/index/getGoodsList',
        method: 'get',
        params: params
    })
}
//公司信息
export function getCompany(params) {
    return request({
        url: '/api/index/getCompany',
        method: 'get',
        params: params
    })
}
//产品list
export function goodslist(params) {
    return request({
        url: '/api/goods/getGoodsList',
        method: 'get',
        params: params
    })
}
//产品详情
export function goodsDetails(params) {
    return request({
        url: '/api/goods/getGoodsDetails',
        method: 'post',
        params: params
    })
}
//添加购物车
export function carAdd(params) {
    return request({
        url: '/api/cart/add',
        method: 'post',
        data: params
    })
}
//收藏商品
export function collect(params) {
    return request({
        url: '/api/goods/collect',
        method: 'post',
        params: params
    })
}
//移除收藏
export function del_collect(params) {
    return request({
        url: '/api/collect/del',
        method: 'post',
        params: params
    })
}
//搜索证书
export function searchCoa(params) {
    return request({
        url: '/api/goods/searchCoa',
        method: 'post',
        params: params
    })
}
//获取直径
export function straight(params) {
    return request({
        url: '/api/goods/getStraight',
        method: 'post',
        params: params
    })
}
//获取厚度
export function thick(params) {
    return request({
        url: '/api/goods/getThick',
        method: 'post',
        params: params
    })
}
//获取规格
export function specs(params) {
    return request({
        url: '/api/goods/getSpecs',
        method: 'post',
        params: params
    })
}
//获取包装
export function getPackage(params) {
    return request({
        url: '/api/goods/getPackage',
        method: 'post',
        params: params
    })
}
//我的订单
export function OrderList(params) {
    return request({
        url: '/api/order/getOrderList',
        method: 'get',
        params: params
    })
}
//个人资料
export function userInfo(params) {
    return request({
        url: '/api/user/getInfo',
        method: 'get',
        params: params
    })
}
//个人资料
export function profile(params) {
    return request({
        url: '/api/user/profile',
        method: 'post',
        params: params
    })
}
//上传文件
export function upload(params) {
    return request({
        url: '/api/common/upload',
        method: 'post',
        params: params
    })
}
//修改密码
export function changepwd(params) {
    return request({
        url: '/api/user/resetpwd',
        method: 'post',
        params: params
    })
}
//我的收藏
export function my_collect(params) {
    return request({
        url: '/api/collect/index',
        method: 'get',
        params: params
    })
}
//我的购物车
export function my_cart(params) {
    return request({
        url: '/api/cart/index',
        method: 'post',
        params: params
    })
}
//修改购物车商品数量
export function setNums(params) {
    return request({
        url: '/api/cart/setNums',
        method: 'post',
        params: params
    })
}
//删除购物车
export function del_car(params) {
    return request({
        url: '/api/cart/delete',
        method: 'post',
        params: params
    })
}
//确认订单
export function confirm_order(params) {
    return request({
        url: '/api/goods/confirmOrder',
        method: 'post',
        params: params
    })
}
//获取收货地址
export function address_list(params) {
    return request({
        url: '/api/address/getAddressList',
        method: 'get',
        params: params
    })
}
//地址信息
export function searchArea(params) {
    return request({
        url: '/api/address/searchArea',
        method: 'post',
        params: params
    })
}
//修改或添加收货地址
export function address_add(params) {
    return request({
        url: '/api/address/addAddressList',
        method: 'get',
        params: params
    })
}
//获取省市区联动列表
export function areaList(params) {
    return request({
        url: '/api/address/getArea',
        method: 'post',
        params: params
    })
}
//删除收货地址
export function deleteAddress(params) {
    return request({
        url: '/api/address/deleteAddressList',
        method: 'post',
        params: params
    })
}
//默认收获地址
export function setDefault(params) {
    return request({
        url: '/api/address/setDefault',
        method: 'post',
        params: params
    })
}
//获取发票信息
export function InvoiceList(params) {
    return request({
        url: '/api/Invoice/getInvoiceList',
        method: 'get',
        params: params
    })
}
//修改或添加发票信息
export function addInvoice(params) {
    return request({
        url: '/api/Invoice/addInvoiceList',
        method: 'post',
        params: params
    })
}
//删除发票
export function deleteInvoice(params) {
    return request({
        url: '/api/Invoice/deleteInvoiceList',
        method: 'post',
        params: params
    })
}
//设置默认发票
export function setInvoice(params) {
    return request({
        url: '/api/Invoice/setDefault',
        method: 'post',
        params: params
    })
}
//获取发票详情
export function InvoiceDetail(params) {
    return request({
        url: '/api/Invoice/getInvoiceDetail',
        method: 'post',
        params: params
    })
}
//提交订单 返回支付参数
export function submit_order(params) {
    return request({
        url: '/api/goods/submitOrder',
        method: 'post',
        params: params
    })
}
//订单详情
export function OrderDetail(params) {
    return request({
        url: '/api/order/getOrderDetail',
        method: 'post',
        params: params
    })
}
//页面底部
export function getPage(params) {
    return request({
        url: '/api/index/getPage',
        method: 'post',
        params: params
    })
}
//页面底部
export function shipperState(params) {
    return request({
        url: '/api/order/shipperState',
        method: 'get',
        params: params
    })
}
//页面底部
export function payOrder(params) {
    return request({
        url: '/api/goods/payOrder',
        method: 'post',
        params: params
    })
}
//物流信息
export function shippingInfo(params) {
    return request({
        url: '/api/order/shippingInfo',
        method: 'post',
        params: params
    })
}
//顶部搜索
export function getsearch(params) {
    return request({
        url: '/api/index/getsearch',
        method: 'get',
        params: params
    })
}
//友情链接
export function getUrl(params) {
    return request({
        url: '/api/index/getUrl',
        method: 'get',
        params: params
    })
}
//广告
export function getAdv(params) {
    return request({
        url: '/api/index/getAdv',
        method: 'get',
        params: params
    })
}
//猜你喜欢
export function getLike(params) {
    return request({
        url: '/api/cart/getLike',
        method: 'get',
        params: params
    })
}
//优惠券列表
export function couponList(params) {
    return request({
        url: '/api/coupon/index',
        method: 'get',
        params: params
    })
}
//优惠券详情
export function couponDet(params) {
    return request({
        url: '/api/coupon/show',
        method: 'post',
        params: params
    })
}
//领取优惠券
export function getCoupon(params) {
    return request({
        url: '/api/coupon/drawCoupon',
        method: 'post',
        data: params
    })
}
//我的优惠券列表
export function userCoupon(params) {
    return request({
        url: '/api/coupon/userCoupon',
        method: 'post',
        params: params
    })
}